<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div
        v-if="canSeeEnquiriesPropertySection"
        class="m-grid__item m-grid__item--fluid m-wrapper"
      >
        <div class="m-content">
          <!--Begin::List-->
          <div
            id="propertyEnquirieList"
            class="row"
          >
            <div class="col-xl-12">
              <!--Begin::Portlet-->

              <div
                class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
                :m-portlet="'true'"
              >
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                        <i class="flaticon-mail m--font-brand m--icon-font-size-lg2 mt-n1" />
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{ heading }}
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                      <li class="m-portlet__nav-item">
                        <a
                          href="javascript:"
                          :m-portlet-tool="'fullscreen'"
                          data-trigger="hover"
                          class="m-portlet__nav-link m-portlet__nav-link--icon"
                        ><i class="la la-expand" /></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="m-portlet__body">
                  <!--Begin::Search-->
                  <div class="row">
                    <div class="col-xl-12">
                      <form
                        action=""
                        @submit.prevent="startSearch"
                      >
                        <div class="row">
                          <div class="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-3 form-group">
                            <div class="form_group">
                              <div class="m-form_label">
                                <label>{{ $t('Property.Enquiries.DateFrom') }}:</label>
                              </div>

                              <input
                                id="FromDate"
                                v-model="params.FromDate"
                                type="date"
                                class="form-control m-input  m-input--solid"
                                name="FromDate"
                                :placeholder="$t('Property.Analytics.From')"
                                required
                                min="2016-04-01"
                              >
                            </div>
                            <div class="d-lg-none m--margin-bottom-10" />
                          </div>

                          <div class="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-3 form-group">
                            <div class="form_group">
                              <div class="m-form_label">
                                <label>{{ $t('Property.Enquiries.DateTo') }}:</label>
                              </div>
                              <input
                                id="ToDate"
                                v-model="params.ToDate"
                                type="date"
                                class="form-control m-input  m-input--solid"
                                min="2016-04-01"
                                :max="maxDayToday"
                                name="ToDate"
                                :placeholder="$t('Property.Analytics.From')"
                                required
                              >
                            </div>
                            <div class="d-lg-none m--margin-bottom-10" />
                          </div>

                          <div class="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-6 form-group pt-xl-4 pt-lg-0 pt-md-0 pt-sm-0 pt-0 mt-2">
                            <button
                              type="submit"
                              class="btn btn-sm btn-brand m-btn m-btn--custom m-btn--icon mt-1 btn-sm-block"
                            >
                              <span>
                                <i class="la la-search" />
                                <span>{{ $t('common.ApplyFilters') }}</span>
                              </span>
                            </button>

                            <button
                              type="button"
                              class="btn btn-sm btn-danger m-btn m-btn--custom m-btn--icon mt-1 btn-sm-block"
                            >
                              <span>
                                <i class="la la-search-minus" />
                                <span @click="clearForm()">{{ $t('Property.form.Clear') }}</span>
                              </span>
                            </button>

                            <button
                              id="filtersBtn"
                              class="btn btn-sm btn-metal m-btn m-btn--custom m-btn--icon mt-1 btn-sm-block"
                              type="button"
                              role="button"
                              data-toggle="collapse"
                              data-target="#PropertyEnquiriesSearchFrm"
                              aria-expanded="false"
                              aria-controls="PropertyEnquiriesSearchFrm"
                            >
                              <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2" />
                              <span
                                id="moreFiltersSpan"
                                class="d-inline moreFiltersSpan"
                              >{{ $t('Property.Analytics.Morefilters') }}</span>
                            </button>
                          </div>
                        </div>

                        <div
                          id="PropertyEnquiriesSearchFrm"
                          style=""
                          class="m-form collapse"
                        >
                          <div class="m-separator m-separator--dashed mt-2" />

                          <div class="m-form m-form--label-align-right">
                            <div class="row align-items-center">
                              <div class="col-xl-12">
                                <div class="form-group row">
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Reference') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.AgentRef"
                                        type="text"
                                        name="AgentRef"
                                        class="form-control m-input  m-input--solid"
                                        :placeholder="$t('Property.Enquiries.placeholder.reference')"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Id') }}:</label>
                                      </div>

                                      <input
                                        v-model.number="params.PropertyId"
                                        type="number"
                                        step="1"
                                        name="PropertyId"
                                        class="form-control m-input m-input--solid"
                                        :placeholder="$t('Property.Enquiries.placeholder.id')"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Type') }}:</label>
                                      </div>
                                      <select
                                        v-model="params.Type"
                                        :value="params.Type"
                                        class="custom-select form-control m-input--solid"
                                      >
                                        <option value="all">
                                          {{ $t('Property.Enquiries.AllEnquiries') }}
                                        </option>
                                        <option value="web">
                                          {{ $t('Property.Enquiries.ContactFormEnquiries') }}
                                        </option>
                                        <option value="phone">
                                          {{ $t('Property.Enquiries.TelephoneEnquiries') }}
                                        </option>
                                        <option value="direct">
                                          {{ $t('Property.Enquiries.DirectEnquiries') }}
                                        </option>
                                        <option value="similar">
                                          {{ $t('Property.Enquiries.SimilarEnquiries') }}
                                        </option>
                                      </select>
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t("Property.form.offertype") }}:</label>
                                      </div>
                                      <select
                                        v-model.number="params.OfferType"
                                        :value="params.OfferType"
                                        class="custom-select form-control m-input--solid"
                                      >
                                        <option value="null">
                                          {{ $t('common.select') }}
                                        </option>
                                        <option value="3">
                                          {{ $t('common.for-sale') }}
                                        </option>
                                        <option value="4">
                                          {{ $t('common.for-rent') }}
                                        </option>
                                        <option value="2">
                                          {{ $t('common.for-holidays') }}
                                        </option>
                                      </select>
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Name') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.Name"
                                        type="text"
                                        name="Name"
                                        class="form-control m-input m-input--solid"
                                        placeholder="Eg: Thomas"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Email') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.Email"
                                        type="text"
                                        name="Email"
                                        class="form-control m-input m-input--solid"
                                        :placeholder="$t('Property.Enquiries.placeholder.email-v2')"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Telephone') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.Phone"
                                        type="text"
                                        name="Phone"
                                        class="form-control m-input m-input--solid"
                                        :placeholder="$t('Property.Enquiries.placeholder.phone')"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Message') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.Comment"
                                        type="text"
                                        name="Comment"
                                        class="form-control m-input m-input--solid"
                                        :placeholder="$t('Property.Enquiries.Message')"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-12 col-md-12 col-sm-12 col-lg-3 form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.EnquiryID') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.EnquiryID"
                                        type="number"
                                        name="EnquiryID"
                                        class="form-control m-input m-input--solid"
                                        placeholder="Eg: 123456"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <button
                                        type="submit"
                                        class="btn-sm btn btn-brand btn-sm font-weight-light m--font-light btn m-btn m-btn--custom m-btn--icon btn-xs-block"
                                      >
                                        <span>
                                          <i class="la la-search" />
                                          <span>{{ $t('common.ApplyFilters') }}</span>
                                        </span>
                                      </button>
                                      <button
                                        type="button"
                                        class="btn-sm btn btn-danger btn-sm font-weight-light m--font-light btn m-btn m-btn--custom m-btn--icon btn-xs-block"
                                      >
                                        <span>
                                          <i class="la la-search-minus" />
                                          <span @click="clearForm()">{{ $t('Property.form.Clear') }}</span>
                                        </span>
                                      </button>
                                      <a
                                        class="btn-sm font-weight-light m--font-light btn btn-metal m-btn m-btn--custom m-btn--icon btn-xs-block"
                                        data-toggle="collapse"
                                        data-keyboard="false"
                                        href="#PropertyEnquiriesSearchFrm"
                                        aria-controls="PropertySearchFrm"
                                      >
                                        <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2" />
                                        <span class="d-inline">{{ $t('Property.Analytics.Hidefilters') }}</span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="m-separator m-separator--dashed mt-2" />
                      </form>
                    </div>
                  </div>
                  <!--End::Search-->

                  <!--Begin::Table-->
                  <div class="row">
                    <div class="col-xl-12 mb-3">
                      <div class="pull-left">
                        {{ $t('Property.table.Records') }}:
                        <span v-if="enquiries.length === 0">{{ $t('Property.table.NoRecordsFound') }}</span>
                        <span v-else-if="enquiries.length > 0 && pagination.total <= recordTo">{{ recordFrom }} {{ $t('Property.table.To') }} {{ recordTo }}</span>
                        <span v-else>{{ recordFrom }} {{ $t('Property.table.To') }} {{ recordTo }} {{ $t('Property.table.From') }}  {{ pagination.total }}</span>
                      </div>
                      <a
                        v-if="userPreferences && userPreferences.ExportEnquiries"
                        class="pull-right"
                        style="cursor:pointer"
                        @click.prevent.stop="exportData"
                      >
                        <span>
                          <i class="la la-download" />
                          <span>{{ $t('common.ExportToExcel') }}</span>
                        </span>
                      </a>
                    </div>
                  </div>

                  <div class="table_sticky-header">
                    <table
                      id="tablePropertiesEnquiries"
                      class="table m-table m-table--head-no-border table table-striped"
                    >
                      <thead class="showMobile">
                        <tr class="">
                          <th
                            style="width:auto;"
                            class="align-middle text-center showMobile"
                            colspan="2"
                          >
                            <div
                              v-if="enquiries.length > 0"
                              class="m-checkbox-inline d-inline pull-left"
                            >
                              <label class="m-checkbox m-checkbox--solid m-checkbox--brand pb-1">
                                <input
                                  id="checkAll"
                                  type="checkbox"
                                  class=""
                                  :checked="allSelected"
                                  @change="selectAll"
                                >
                                <span />
                              </label>
                            </div>

                            <div
                              v-if="selectedEnquiries.length !== 0"
                              id="dropDownActions"
                              class="pull-left m-dropdown m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-left m-dropdown--mobile-full-width d-inline"
                            >
                              <dropdown
                                btn-class="m-dropdown__toggle btn btn-xs btn-outline-brand dropdown-toggle m--regular-font-size-sm2"
                              >
                                <template #btn>
                                  {{ $t('Property.table.actions') }}
                                </template>
                                <template #dropdown>
                                  <span class="m-dropdown__arrow m-dropdown__arrow--left text-white" />
                                  <div class="m-dropdown__inner">
                                    <div class="m-dropdown__body">
                                      <div class="m-dropdown__content">
                                        <ul class="m-nav m-nav--skin-light text-center">
                                          <li class="m-nav__item">
                                            <label for="AgentEmailResend">{{ $t('Property.Enquiries.Resend') }}</label>
                                            <input
                                              id="AgentEmailResend"
                                              v-model="agentEmail"
                                              required
                                              type="email"
                                              class="form-control form-control-sm m-input m-input--solid mb-2"
                                              placeholder="forward@email.to"
                                            >
                                            <button
                                              class="btn btn-sm btn-brand"
                                              @click="resendEmail"
                                            >
                                              {{ $t('Property.Enquiries.ResendSelectedEmails') }}
                                            </button>
                                            <div class="separata mt-4" />
                                          </li>
                                          <li class="m-nav__item mt-3">
                                            <label>{{ $t('Property.Enquiries.Report') }}</label>
                                            <button
                                              class="btn btn-sm btn-info btn-block"
                                              @click="reportSpam"
                                            >
                                              {{ $t('Property.Enquiries.Spam') }}
                                            </button>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </dropdown>
                            </div>
                          </th>
                          <th
                            style="width:15%;"
                            class="text-left"
                          >
                            {{ $t('Property.Enquiries.Date') }}<small> / </small>{{ $t('Property.table.Id') }}<small>
                              / </small>{{ $t('Property.Enquiries.Ref') }} <small>/</small> {{ $t('Property.form.Price') }}
                          </th>
                          <th
                            style="width:20%;"
                            class="text-left"
                          >
                            {{ $t('Property.Enquiries.From') }}
                          </th>
                          <th
                            style="width:auto;"
                            class="text-left"
                          >
                            {{ $t('Property.Enquiries.Language') }}<small>
                              / </small>{{ $t('Property.Enquiries.Location') }}
                          </th>
                          <th
                            style="width:35%;"
                            class="text-left"
                          >
                            {{ $t('Property.Enquiries.Message') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(enquiry, index) in enquiries"
                          :key="index"
                          :class="getSpamColor(enquiry)"
                        >
                          <td
                            class="align-middle"
                            data-thead-name=""
                          >
                            <div class="m-checkbox-inline-block">
                              <label class="m-checkbox m-checkbox--solid m-checkbox--brand">
                                <input
                                  v-model="selectedEnquiries"
                                  type="checkbox"
                                  class=""
                                  :value="enquiry"
                                >
                                <span />
                              </label>
                            </div>
                          </td>
                          <td
                            class="align-middle"
                            data-thead-name=""
                          >
                            <template v-if="enquiry.Type === 'iovox-call'">
                              <span :class="{'text-nowrap d-block mb-2': !!enquiry.Property}">
                                <i class="la la-phone la-phone-valign" />
                                <template v-if="enquiry.Data.Destination && enquiry.Data.Destination.toLowerCase() !== 'not applicable'">
                                  +{{ enquiry.Data.Destination }}
                                </template>
                                <template v-else-if="enquiry.Data.Reason && enquiry.Data.Reason.toLowerCase() === 'time based'">
                                  {{ $t("Property.Enquiries.IOVOX.HANGUP") }}
                                </template>
                                <template v-else>
                                  {{ $t("calls.outOfHours") }}
                                </template>
                              </span>
                            </template>
                            <template v-if="enquiry.Property">
                              <a
                                :href="getPropertyURLForEnquiry(enquiry)"
                                target="_blank"
                              >
                                <template v-if="getFirstPhoto(enquiry.Property)">
                                  <div class="thumbnailTable">
                                    <div class="ratio-4-3">
                                      <img :src="photoUrl(getFirstPhoto(enquiry.Property))">
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <span class="img-cont">
                                    <i class="la la-camera m--icon-font-size-lg3 d-block" />
                                    <span class="d-block small">{{ $t('common.NoImages') }}</span>
                                  </span>
                                </template>
                              </a>
                            </template>
                            <template v-if="enquiry.Data.Match && enquiry.Data.Match.propertyIDs && enquiry.Data.Match.propertyIDs.length > 1">
                              <button
                                type="button"
                                class="btn btn-link p-0 mt-2 d-block text-left"
                                @click="showCallMatchInfo( enquiry )"
                              >
                                {{ $t('Property.Enquiries.multipleCallMatchesInfoBtn') }}
                              </button>
                            </template>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t('Property.Enquiries.Date')+' / '+$t('Property.Enquiries.Id')+ ' / '+ $t('Property.Enquiries.Ref') +' / '+$t('Property.form.Price')"
                            :title="`${enquiry.Data.Id}`"
                          >
                            <span
                              class="d-block"
                              :title="`${enquiry.Data.Id}`"
                            >
                              <template v-if="enquiry.Type === 'iovox-call'">
                                {{ formatDate(enquiry.Data.Start) }}
                              </template>
                              <template v-else>
                                {{ formatDate(enquiry.Data.SendDate) }}
                              </template>
                            </span>
                            <a
                              v-if="getPropertyIDForEnquiry( enquiry ) > 0"
                              :href="getPropertyURLForEnquiry(enquiry)"
                              target="_blank"
                              class="d-block mt-2"
                            >
                              {{ getPropertyIDForEnquiry( enquiry ) }}
                            </a>
                            <template v-if="getAgentRefForEnquiry( enquiry ) !== ''">
                              <strong class="d-block mt-2">{{ getAgentRefForEnquiry( enquiry ) }}</strong>
                            </template>
                            <span
                              v-if="enquiry.Property"
                              class="d-block mt-2"
                              v-html="showPrice(enquiry.Property)"
                            />
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t('Property.Enquiries.From')"
                          >
                            <template v-if="enquiry.Data.Email">
                              {{ enquiry.Data.Name }}
                              <template v-if="enquiry.Data.Email">
                                <a
                                  :href="`mailto:${enquiry.Data.Email}?body=${uriEncode(enquiry.Data.PropertyURL)}`"
                                  rel="noopener noreferrer nofollow"
                                  class="d-block mt-2"
                                >{{ enquiry.Data.Email }}</a>
                              </template>
                              <template v-if="enquiry.Data.Phone">
                                <span class="d-block mt-2">
                                  {{ enquiry.Data.Phone }}
                                  <a
                                    :href="`tel:${formatTel(enquiry.Data.Phone, true)}`"
                                    class="ml-3"
                                  ><i class="la la-phone" /></a>
                                  <a
                                    :href="`https://wa.me/${formatTel(enquiry.Data.Phone, true)}?text=${uriEncode(enquiry.Data.PropertyURL)}`"
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                    class="ml-2"
                                  ><i class="la la-whatsapp" /></a>
                                </span>
                              </template>
                            </template>
                            <template v-else>
                              <span class="d-block">
                                +{{ enquiry.Data.Origin }}
                                <a
                                  :href="`tel:+${formatTel(enquiry.Data.Origin)}`"
                                  class="ml-3"
                                ><i class="la la-phone" /></a>
                                <a
                                  :href="`https://wa.me/+${formatTel(enquiry.Data.Origin)}?text=${uriEncode(getPropertyURLForEnquiry(enquiry, false))}`"
                                  target="_blank"
                                  rel="noopener noreferrer nofollow"
                                  class="ml-2"
                                ><i class="la la-whatsapp" /></a>
                              </span>
                            </template>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t('Property.Enquiries.Language')+' / '+$t('Property.Enquiries.Location')"
                          >
                            <template v-if="enquiry.Type === 'web-enquiry' && enquiry.Data.Language">
                              <span>
                                <img
                                  alt=""
                                  width="25px"
                                  class="m--hidden-tablet-and-mobile"
                                  :src="cdnURL+'/img/flags/'+ getFlag(enquiry.Data.Language.toLowerCase())+'.png'"
                                >
                                {{ enquiry.Data.Language.toUpperCase() }}
                              </span>
                            </template>
                            <template v-if="enquiry.Type === 'web-enquiry' && enquiry.Data.Country">
                              <span :class="{'d-block':true,'mt-2':enquiry.Type === 'web-enquiry' && enquiry.Data.Language}">
                                <i class="la la-map-marker m--hidden-tablet-and-mobile" />
                                {{ enquiry.Data.Country.toUpperCase() }}
                              </span>
                            </template>
                            <template v-if="enquiry.Type === 'iovox-call' && enquiry.Data.Match && enquiry.Data.Match.events && enquiry.Data.Match.events.length > 0">
                              <span class="d-block">
                                <img
                                  alt=""
                                  width="25px"
                                  class="m--hidden-tablet-and-mobile"
                                  :src="cdnURL+'/img/flags/'+ getFlag(enquiry.Data.Match.events[ 0 ].language.toLowerCase())+'.png'"
                                >
                                {{ enquiry.Data.Match.events[ 0 ].language.toUpperCase() }}
                              </span>
                              <span class="d-block mt-2">
                                <i class="la la-map-marker m--hidden-tablet-and-mobile" />
                                {{ enquiry.Data.Match.events[ 0 ].viewerCountry.toUpperCase() }}
                              </span>
                            </template>
                            <template v-else-if="enquiry.Type === 'iovox-call' && enquiry.Data.Start">
                              <span class="mt-2 d-block">
                                <i class="la la-map-marker" />
                                {{ (enquiry.Data.OriginLocation || "").replace(/,(?! )/, ', ') }}
                              </span>
                            </template>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t('Property.Enquiries.Message')"
                          >
                            <template v-if="enquiry.Data.Result">
                              {{ $t('Property.Enquiries.IOVOX.'+enquiry.Data.Result) }}
                              <span v-if="enquiry.Data.TalkTimeSec > 0">({{ $t('Property.Enquiries.CallTime') }}: {{ formatDuration(enquiry.Data.TalkTimeSec) }})</span>
                            </template>
                            <template v-if="enquiry.Data.Comment">
                              <span
                                v-if="enquiry.Data.Comment.length <= 280"
                                class="comment"
                              >
                                {{ enquiry.Data.Comment }}
                              </span>
                              <span v-else>
                                <span class="comment">
                                  {{ shortDescription(enquiry.Data.Comment) }}
                                </span>
                                <a
                                  href="javascript:"
                                  :data-ts-full-desc="enquiry.Data.Comment"
                                  :data-ts-short-desc="shortDescription(enquiry.Data.Comment)"
                                  @click="replaceShortDescByFull"
                                >
                                  <span class="see-more ml-2"> <small>[{{ $t('Property.Enquiries.seeMore') }} +]</small></span>
                                  <span
                                    class="see-less m--hide ml-2"
                                  ><small>[{{ $t('Property.Enquiries.seeLess') }} -]</small></span>
                                </a>

                              </span>
                            </template>
                            <template v-if="enquiry.Data && enquiry.Data.IsWhatsApp">
                              <p class="mb-0 mt-2 d-inline-flex font-italic">
                                <i class="la la-whatsapp text-whatsapp mr-2" /> {{ $t( 'Property.Enquiries.sentWithWhatsApp' ) }}
                              </p>
                            </template>
                          </td>
                        </tr>
                        <tr v-if="enquiries.length === 0">
                          <td
                            colspan="11"
                            class="text-center m--regular-font-size-lg3 py-5"
                          >
                            <template v-if="!loading">
                              {{ $t('Property.table.NoRecordsFound') }}
                            </template>
                            <template v-else>
                              {{ $t('common.sendingDataPleaseWait') }}
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="m-separator m-separator--dashed mt-2" />
                  </div>
                  <!--End::Table-->

                  <!--Begin::Pagination-->
                  <Pagination
                    :total-pages="pagination.totalPages"
                    :total="pagination.total"
                    :loading="false"
                    :current-page="pagination.currentPage"
                    @pagechanged="onPageChange"
                  />
                  <!--End::Pagination-->
                </div>
              </div>

              <!--end: Portlet-->
            </div>
          </div>
          <!--End::List-->
        </div>
      </div>
      <template v-if="canSeeContractService">
        <NoPropertyServices />
      </template>

      <CallMatchInfo
        :enquiry="enquiryForMatchInfo"
        @close="enquiryForMatchInfo = null"
      />
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter />
    <!-- END: Footer -->
  </div>
</template>
<script>
import { getUser, getPropertyService, onBeforeOpenSwal } from '../../../../functions.ts';
import Pagination from '../../common/Pagination.vue';
import AppHeader from '../../common/Header.vue';
import AppFooter from '../../common/Footer.vue';
import LeftMenu from '../../common/menus/LeftMenu.vue';
import NoPropertyServices from '../../services/Property.vue';
import dayjs from 'dayjs';
import { formatPhoneForTelLink } from '../../../../common/tel.ts';
import { clientapi } from '../../../../api-clients/client-api.js';
import CallMatchInfo from './CallMatchInfo.vue';
import Dropdown from '../../../Dropdown.vue';

export default {
    components: {
        Pagination,
        AppFooter,
        AppHeader,
        LeftMenu,
        NoPropertyServices,
        CallMatchInfo,
        Dropdown,
    },
    data() {
        return {
            user: {},
            userPreferences: {},
            propertyService: null,
            params: {
                Spam: false,
                Skip: 0,
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().format( 'YYYY-MM-DD' ),
                AgentRef: '',
                PropertyId: '',
                Name: '',
                Email: '',
                Phone: '',
                Type: 'all',
                Comment: '',
                OfferType: null,
                EnquiryID: null,
            },
            searchParams: {},
            agentEmail: '',
            selectedEnquiries: [],
            pagination: {
                total: 0,
                totalPages: 0,
                currentPage: 1,
            },
            enquiries: [],
            totalEnquiries: 0,
            loading: false,
            cdnURL: import.meta.env.TWC_CDN_URL,
            total: 0,
            resultsPerPage: 20,
            enquiryForMatchInfo: null,
            canViewStatuses: [ 'ACTIVE', 'ACTIVE_FUTURE' ],
        };
    },
    computed: {
        heading() {
            switch ( this.searchParams.Type ) {
            case 'web': return this.$t( 'Property.Enquiries.ContactFormEnquiries' ) + this.$t( 'Property.headingSuffix' );
            case 'phone': return this.$t( 'Property.Enquiries.TelephoneEnquiries' ) + this.$t( 'Property.headingSuffix' );
            case 'direct': return this.$t( 'Property.Enquiries.DirectEnquiries' ) + this.$t( 'Property.headingSuffix' );
            case 'similar': return this.$t( 'Property.Enquiries.SimilarEnquiries' ) + this.$t( 'Property.headingSuffix' );
            }

            return this.$t( 'Property.Enquiries.AllEnquiries' )  + this.$t( 'Property.headingSuffix' );
        },
        recordFrom() {
            return ( this.resultsPerPage * ( this.pagination.currentPage - 1 ) ) + 1;
        },
        recordTo() {
            return Math.min( this.recordFrom + this.resultsPerPage - 1, this.pagination.total );
        },
        canSeeEnquiriesPropertySection() {
            return this.propertyService !== null && this.canViewStatuses.includes( this.propertyService.Status );
        },
        canSeeContractService() {
            return this.propertyService !== null && !this.canViewStatuses.includes( this.propertyService.Status );
        },
        maxDayToday() {
            return dayjs().tz().format( 'YYYY-MM-DD' );
        },
        allSelected() {
            return this.selectedEnquiries.length === this.enquiries.length;
        },
    },
    watch: {
        '$route.query': {
            handler: function( newQuery, oldQuery ) {
                this.updateParamsFromRoute();
                if ( this.canSeeEnquiriesPropertySection ) {
                    this.doSearch();
                }
            },
            immediate: false,
        },
    },
    async created() {
        let userPreferencesCall = clientapi.get( '/agent/preferences' );

        this.user = getUser();

        this.propertyService = await getPropertyService();

        this.agentEmail = this.user.Email;

        if ( this.propertyService && this.propertyService.Outlet && this.propertyService.Outlet.Email ) {
            this.agentEmail = this.propertyService.Outlet.Email;
        }

        this.updateParamsFromRoute();

        if ( this.canSeeEnquiriesPropertySection ) {
            this.doSearch();
            this.setUpHideShowFilters();
        }

        this.userPreferences = ( await userPreferencesCall ).data;
    },
    methods: {
        showCallMatchInfo( enquiry ) {
            this.enquiryForMatchInfo = enquiry;
        },
        getPropertyURLForEnquiry( e, includePreviewParam = true ) {
            if ( e.Data && e.Data.Match && e.Data.Match.propertyIDs && e.Data.Match.propertyIDs.length === 1 ) {
                return this.getCallMatchPropertyURL( e.Data.Match, e, includePreviewParam );
            }

            if ( e.Data && e.Data.PropertyURL ) {
                let u = e.Data.PropertyURL;

                if ( includePreviewParam ) {
                    u += '?preview=1';
                }

                return u;
            }

            return '';
        },
        getPropertyIDForEnquiry( e ) {
            if ( e.Property ) {
                return e.Property.Id;
            }

            if ( e.Data && e.Data.Match && e.Data.Match.propertyIDs && e.Data.Match.propertyIDs.length === 1 ) {
                return e.Data.Match.propertyIDs[ 0 ];
            }

            return 0;
        },
        getAgentRefForEnquiry( e ) {
            if ( e.Property && e.Property.AgentRef ) {
                return e.Property.AgentRef;
            }

            return '';
        },
        getCallMatchPropertyURL( match, enquiry, includePreviewParam = true ) {
            const offer = enquiry.Property.OfferType.Name;

            let path = '';

            switch ( offer ) {
            case 'for-sale':
                path = `property-for-sale/${match.propertyIDs[ 0 ]}`;
                break;
            case 'for-rent':
                path = `property-to-rent-long-term/${match.propertyIDs[ 0 ]}`;
                break;
            case 'for-holidays':
                path = `holiday-rentals/${match.propertyIDs[ 0 ]}`;
                break;
            }

            const u = new URL( `https://www.thinkspain.com/${path}` );

            if ( includePreviewParam ) {
                u.search = 'preview=1';
            }

            return u.toString();
        },
        getDefaultParams() {
            return {
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().format( 'YYYY-MM-DD' ),
                Spam: false,
                Skip: 0,
                AgentRef: '',
                PropertyId: '',
                Name: '',
                Email: '',
                Phone: '',
                Type: 'all',
                Comment: '',
                OfferType: null,
                EnquiryID: null,
            };
        },
        updateParamsFromRoute() {
            let defaultParams = this.getDefaultParams();
            this.params.FromDate = this.$route.query.fromdate || defaultParams.FromDate;
            this.params.ToDate = this.$route.query.todate || defaultParams.ToDate;
            this.params.Spam = this.$route.query.spam || defaultParams.Spam;
            this.params.Skip = this.$route.query.skip || defaultParams.Skip;
            this.params.AgentRef = this.$route.query.agentref || defaultParams.AgentRef;
            this.params.PropertyId = this.$route.query.propertyid || defaultParams.PropertyId;
            this.params.Name = this.$route.query.name || defaultParams.Name;
            this.params.Email = this.$route.query.email || defaultParams.Email;
            this.params.Phone = this.$route.query.phone || defaultParams.Phone;
            this.params.Type = this.$route.query.type || defaultParams.Type;
            this.params.Comment = this.$route.query.comment || defaultParams.Comment;
            this.params.OfferType = this.$route.query.offertype || defaultParams.OfferType;
            this.params.EnquiryID = this.$route.query.id || defaultParams.EnquiryID;
        },
        updateRouteFromParams() {
            let defaultParams = this.getDefaultParams();

            let newRouteParams = {
                fromdate: this.params.FromDate,
                todate: this.params.ToDate,
            };

            if ( this.params.Spam !== defaultParams.Spam ) {
                newRouteParams.spam = this.params.Spam;
            }

            if ( this.params.Skip !== defaultParams.Skip ) {
                newRouteParams.skip = this.params.Skip;
            }

            if ( this.params.AgentRef !== defaultParams.AgentRef ) {
                newRouteParams.agentref = this.params.AgentRef;
            }

            if ( this.params.PropertyId !== defaultParams.PropertyId ) {
                newRouteParams.propertyid = this.params.PropertyId;
            }

            if ( this.params.Name !== defaultParams.Name ) {
                newRouteParams.name = this.params.Name;
            }

            if ( this.params.Email !== defaultParams.Email ) {
                newRouteParams.email = this.params.Email;
            }

            if ( this.params.Phone !== defaultParams.Phone ) {
                newRouteParams.phone = this.params.Phone;
            }

            if ( this.params.Type !== defaultParams.Type ) {
                newRouteParams.type = this.params.Type;
            }

            if ( this.params.Comment !== defaultParams.Comment ) {
                newRouteParams.comment = this.params.Comment;
            }

            if ( this.params.OfferType !== defaultParams.OfferType ) {
                newRouteParams.offertype = this.params.OfferType;
            }

            if ( this.params.EnquiryID !== defaultParams.EnquiryID ) {
                newRouteParams.id = this.params.EnquiryID;
            }

            if ( JSON.stringify( this.$route.query ) !== JSON.stringify( newRouteParams ) ) {
                this.$router.push( { query: newRouteParams } );
            }
        },
        selectAll() {
            if ( this.allSelected ) {
                this.selectedEnquiries = [];
                return;
            }
            this.selectedEnquiries = this.enquiries;
        },
        clearForm() {
            this.params = this.getDefaultParams();
        },
        onPageChange( page ) {
            this.params.Skip = ( page - 1 ) * this.resultsPerPage;
            this.selectedEnquiries = [];
            this.updateRouteFromParams();
        },
        setUpHideShowFilters() {
            let component = this;
            let $form = $( '#PropertyEnquiriesSearchFrm' );
            $form.on( 'hide.bs.collapse', function() {
                document.getElementById( 'moreFiltersSpan' ).innerHTML = component.$t( 'Property.Analytics.MoreFilters' );
            } );
            $form.on( 'show.bs.collapse', function() {
                document.getElementById( 'moreFiltersSpan' ).innerHTML = component.$t( 'Property.Analytics.Hidefilters' );
            } );
        },
        formatMoney( price ) {
            return this.$utils.formatNumber( price, null, 0 );
        },
        getFirstPhoto( property ) {
            let photos = property.Photos;

            if ( !photos || photos.length === 0 ) {
                return null;
            }

            let photo = photos[ 0 ];

            for ( let p of photos ) {
                if ( p.Number < photo.Number ) {
                    photo = p;
                }
            }
            return photo;
        },
        photoUrl( photo ) {
            if ( !photo.CdnUrl ) {
                return photo.Url;
            }

            let url = photo.CdnUrl;
            let urlChunks = url.split( '/' );

            if ( urlChunks.length < 3 ) {
                return '';
            }

            // use https if http is returned
            if ( urlChunks[ 0 ] === 'http:' ) {
                urlChunks[ 0 ] = 'https:';
            }

            urlChunks.splice( urlChunks.length - 1, 0, 's400x300' );

            return urlChunks.join( '/' );
        },
        formatDuration( totalSeconds ) {
            let hours = Math.floor( totalSeconds / 60 / 60 );
            let minutes = Math.floor( totalSeconds / 60 - ( hours * 60 ) );
            let seconds = Math.floor( totalSeconds - ( hours * 60 * 60 ) - ( minutes * 60 ) );

	      return `${hours.toString().padStart( 2, '0' )}:${minutes.toString().padStart( 2, '0' )}:${seconds.toString().padStart( 2, '0' )}`;
        },
        async startSearch() {
            this.params.Skip = 0;
            this.updateRouteFromParams();
        },
        async doSearch() {
            this.selectedEnquiries = [];

            this.searchParams = {};
            this.searchParams.Skip = this.params.Skip;
            this.searchParams.Spam = false;
            this.searchParams.Deleted = false;
            this.searchParams.Take = this.resultsPerPage;
            this.searchParams.FromDate = dayjs.tz( this.params.FromDate, 'YYYY-MM-DD', 'Europe/Madrid' ).format();
            this.searchParams.ToDate = dayjs.tz( this.params.ToDate, 'YYYY-MM-DD', 'Europe/Madrid' ).endOf( 'day' ).format();

            if ( this.params.Name.length > 0 ) {
                this.searchParams.Name = `%${this.params.Name}%`;
            }

            if ( this.params.Email.length > 0 ) {
                this.searchParams.Email = `%${this.params.Email}%`;
            }

            if ( this.params.Phone.length > 0 ) {
                this.searchParams.Phone = `%${this.params.Phone}%`;
            }

            if ( this.params.Comment.length > 0 ) {
                this.searchParams.Comment = `%${this.params.Comment}%`;
            }

            if ( this.params.Type.length > 0 && this.params.Type !== 'all' ) {
                this.searchParams.Type = this.params.Type;
            }

            if ( this.params.AgentRef.length > 0 ) {
                this.searchParams.AgentRef = `%${this.params.AgentRef}%`;
            }

            if ( this.params.PropertyId > 0 ) {
                this.searchParams.PropertyId = this.params.PropertyId;
            }

            if ( this.params.OfferType > 0 ) {
                this.searchParams.Offer = this.params.OfferType;
            }

            if ( this.params.EnquiryID ) {
                this.searchParams.Id = this.params.EnquiryID;
            }

            await this.doSearchFromSearchParams();
        },
        uriEncode( v ) {
            return encodeURIComponent( v );
        },
        async exportData() {
            this.loading = true;
            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            let params = JSON.parse( JSON.stringify( this.searchParams ) );

            delete params[ 'Take' ];
            delete params[ 'Skip' ];
            params[ 'Language' ] = this.$i18n.locale;

            let exportQuery = clientapi.get( '/propertycontacts/export', {
                responseType: 'blob',
                params: params,
            } );

            let exportResult = await exportQuery;

            this.loading = false;
            mApp.unblock( 'body' );

            if ( exportResult.status !== 200 ) {
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            const url = window.URL.createObjectURL( new Blob( [ exportResult.data ] ) );
            const link = document.createElement( 'a' );
            link.href = url;
            link.setAttribute( 'download', 'enquiries.xlsx' ); // or any other extension
            document.body.appendChild( link );
            link.click();
        },
        async doSearchFromSearchParams() {
            this.loading = true;
            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            let params = this.searchParams;

            let contacts = clientapi.get( '/propertycontacts', { params: this.searchParams } );

            let countParams = JSON.parse( JSON.stringify( params ) );

            delete countParams[ 'Take' ];
            delete countParams[ 'Skip' ];

            let stats = clientapi.get( '/propertycontacts/stats', { params: countParams } );

            contacts = ( await contacts ).data;

            let webEnquiryIds = contacts.filter( ( c ) => c.Type === 'web-enquiry' ).map( ( c ) => c.Identifier );
            let iovoxIds = contacts.filter( ( c ) => c.Type === 'iovox-call' ).map( ( c ) => c.Identifier );

            let iovoxCallsFunc = async () => {
                if ( iovoxIds.length === 0 ) {
                    return { status: 200,
                        data: [] };
                }

                return await clientapi.get( '/calls/property?' + iovoxIds.map( ( el ) => 'Id=' + el ).join( '&' ) );
            };

            let webEnquiryFunc = async () => {
                if ( webEnquiryIds.length === 0 ) {
                    return { status: 200,
                        data: [] };
                }

                return await clientapi.get( '/propertyenquiries?' + webEnquiryIds.map( ( el ) => 'Id=' + el ).join( '&' ) );
            };

            let iovoxCalls = ( await iovoxCallsFunc() ).data;
            let webEnquiries = ( await webEnquiryFunc() ).data;

            let allEnquieries = [];

            for ( let enq of contacts ) {
                switch ( enq.Type ) {
                case 'web-enquiry': {
                    let data = webEnquiries.find( ( e ) => e.Id == enq.Identifier );

                    let e = {
                        Type: enq.Type,
                        Data: {},
                    };

                    if ( data ) {
                        e.Data = data;
                    } else {
                        throw new Error( `no enquiry data found for ${JSON.stringify( enq )}` );
                    }

                    allEnquieries.push( e );
                    break;
                }
                case 'iovox-call': {
                    let data = iovoxCalls.find( ( e ) => e.Id == enq.Identifier );

                    let e = {
                        Type: enq.Type,
                        Data: {},
                    };

                    if ( data ) {
                        e.Data = data;
                    } else {
                        throw new Error( `no enquiry data found for ${JSON.stringify( enq )}` );
                    }

                    allEnquieries.push( e );
                    break;
                }
                }
            }

            let propertyIds = [];

            allEnquieries.forEach( ( enquiry ) => {
                let ids = [];

                if ( enquiry.Data && enquiry.Data.PropertyId ) {
                    ids.push( enquiry.Data.PropertyId );
                } else if ( enquiry.Data && enquiry.Data.Match && enquiry.Data.Match.propertyIDs && enquiry.Data.Match.propertyIDs.length > 0 ) {
                    ids = [ ...enquiry.Data.Match.propertyIDs ];
                }

                ids.forEach( ( id ) => {
                    if ( id !== 0 && !propertyIds.includes( id ) ) {
                        propertyIds.push( id );
                    }
                } );
            } );

            if ( propertyIds.length > 0 ) {
                const params = new URLSearchParams();
                params.set( 'Take', propertyIds.length );

                propertyIds.forEach( ( propertyID ) => params.append( 'Id', propertyID ) );

                let propertiesCall = await clientapi.get( `/property?${params.toString()}` );

                let properties = propertiesCall.data;

                allEnquieries = allEnquieries.map( ( enquiry ) => {
                    if ( enquiry.Data && enquiry.Data.PropertyId ) {
                        enquiry.Property = properties.find( ( property ) => property.Id === enquiry.Data.PropertyId );
                    }

                    if ( enquiry.Data && enquiry.Data.Match && enquiry.Data.Match.propertyIDs && enquiry.Data.Match.propertyIDs.length === 1 ) {
                        enquiry.Property = properties.find( ( property ) => property.Id === enquiry.Data.Match.propertyIDs[ 0 ] );
                    }

                    if ( enquiry.Data && enquiry.Data.Match && enquiry.Data.Match.propertyIDs && enquiry.Data.Match.propertyIDs.length > 1 ) {
                        enquiry.Properties = properties.filter( ( property ) => enquiry.Data.Match.propertyIDs.includes( property.Id ) );
                    }

                    return enquiry;
                } );
            }

            // add property information to all web-enquiry call

            let statsResult = await stats;

            if ( statsResult.status === 200 ) {
                this.pagination.total = statsResult.data.count;
                this.pagination.currentPage = Math.ceil( this.searchParams.Skip / this.resultsPerPage ) + 1;
                this.pagination.totalPages = Math.ceil( this.pagination.total / this.searchParams.Take );
            }

            this.enquiries = allEnquieries;

            mApp.unblock( 'body' );
            this.loading = false;
        },
        showPrice( item ) {
            return this.$utils.showPrice( item );
        },
        getSpamColor( enquiry ) {
            if ( enquiry.Type === 'iovox-call' ) {
                return 'isIOVOX';
            }

            let webEnquiry = enquiry.Data;

            if ( webEnquiry && webEnquiry.IsSpam ) {
                return 'isSpam';
            }

            if ( webEnquiry && !webEnquiry.IsSpam && !webEnquiry.IsSent ) {
                return 'noSpamNoSend';
            }

            return 'noColor';
        },
        replaceShortDescByFull( event ) {
            let target = event.target;

            let comment_cont = target.parentNode.parentNode.parentNode.getElementsByClassName( 'comment' )[ 0 ];
            let full_text = target.parentNode.parentNode.parentNode.querySelectorAll( '[data-ts-full-desc]' )[ 0 ].dataset[ 'tsFullDesc' ];
            let short_text = target.parentNode.parentNode.parentNode.querySelectorAll( '[data-ts-short-desc]' )[ 0 ].dataset[ 'tsShortDesc' ];
            let see_more = target.parentNode.parentNode.parentNode.getElementsByClassName( 'see-more' )[ 0 ];
            let see_less = target.parentNode.parentNode.parentNode.getElementsByClassName( 'see-less' )[ 0 ];

            if ( see_less.classList.contains( 'm--hide' ) ) {
                see_more.classList.add( 'm--hide' );
                see_less.classList.remove( 'm--hide' );
                comment_cont.innerHTML = full_text;
            } else {
                see_less.classList.add( 'm--hide' );
                see_more.classList.remove( 'm--hide' );
                comment_cont.innerHTML = short_text;
            }
        },
        shortDescription( text ) {
            if ( text.length > 280 ) {
                return text.substring( 0, 225 ) + '...';
            }
            return text;
        },
        formatDate( date ) {
            return dayjs( date ).tz().format( 'DD/MM/YYYY H:mm' );
        },
        getFlag( country ) {
            if ( country === 'en' ) {
                return 'gb';
            }
            return country;
        },
        async resendEmail() {
            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            let email = this.agentEmail;

            let send = async ( enq ) => {
                let id = enq.Data.Id;
                if ( enq.Type === 'iovox-call' ) {
                    let result = await clientapi.post( `/calls/property/${id}/send`, { email: email,
                        language: this.$i18n.locale } );
                    return result.status === 200;
                } else {
                    let result = await clientapi.post( `/propertyenquiries/${id}/resend`, { email: email,
                        language: this.$i18n.locale } );
                    return result.status === 200;
                }
            };

            let promises = [];

            for ( let enq of this.selectedEnquiries ) {
                let localEnq = Object.assign( {}, enq );
                promises.push( send( enq ) );
            }

            let results = await Promise.all( promises );

            mApp.unblock( 'body' );

            let withSuccess = results.filter( ( r ) => r ).length;
            let withError = results.filter( ( r ) => !r ).length;

            if ( !withError ) {
                this.selectedEnquiries = [];
            }

            let title = this.$t( 'Property.Enquiries.TotalEmailSend' );
            let html = '';
            let type = 'info';
            if ( withError > 0 ) {
                html = `<spam class="d-block">${this.$t( 'Property.Enquiries.Failed' )}: <span class="m--font-boldest">${withError}</span></spam>`;
                type = 'warning';
            } else if ( withSuccess > 0 ) {
                html = `<spam class="d-block">${this.$t( 'Property.Enquiries.enquiriesSended' )}: <span class="m--font-boldest">${withSuccess}</span></spam>`;
            }

            swal( {
                title: title,
                html: html,
                showCancelButton: false,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'common.ok' ),
                type: type,
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );
        },
        async reportSpam() {
            let isConfirm = await swal( {
                title: this.$t( 'Property.Enquiries.reportType', { type: 'spam' } ),
                text: this.$t( 'Property.Enquiries.confirmSpam', this.selectedEnquiries.length, { type: 'spam' } ),
                showCancelButton: true,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'Property.Enquiries.yesReportIt' ),
                cancelButtonText: this.$t( 'common.Cancel' ),
                input: 'textarea',
                inputPlaceholder: this.$t( 'Property.Enquiries.spamReasonPlaceholder' ),
                inputValidator: ( value ) => {
                    if ( !value ) {
                        return this.$t( 'Property.Enquiries.spamReasonInvalidField' );
                    }
                },
                type: 'warning',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );

            if ( isConfirm.dismiss ) {
                return;
            }

            if ( !isConfirm.value ) {
                return;
            }

            let reason = isConfirm.value;

            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            let email = this.agentEmail;

            let send = async ( enq ) => {
                let id = enq.Data.Id;
                if ( enq.Type === 'iovox-call' ) {
                    let result = await clientapi.post( `/calls/property/${id}/markasspam`, { email: email,
                        reason: reason } );
                    return result.status === 200;
                } else {
                    let result = await clientapi.post( `/propertyenquiries/${id}/markasspam`, { email: email,
                        reason: reason } );
                    return result.status === 200;
                }
            };

            let promises = [];

            for ( let enq of this.selectedEnquiries ) {
                let localEnq = Object.assign( {}, enq );
                promises.push( send( enq ) );
            }

            let results = await Promise.all( promises );

            let withSuccess = results.filter( ( r ) => r ).length;
            let withError = results.filter( ( r ) => !r ).length;

            if ( !withError ) {
                this.selectedEnquiries = [];
            }

            mApp.unblock( 'body' );

            let title = this.$t( 'Property.Enquiries.TotalEmailMarked' );
            let html = '';
            let type = 'info';

            if ( withError > 0 ) {
                html += `<spam class="d-block">${this.$t( 'Property.Enquiries.Failed' )}: <span class="m--font-boldest">${withError}</span></spam>`;
                type = 'warning';
            } else if ( withSuccess > 0 ) {
                html = `<spam class="d-block">${this.$t( 'Property.Enquiries.enquiriesMarked' )}: <span class="m--font-boldest">${withSuccess}</span></spam>`;
            }

            swal( {
                title: title,
                html: html,
                showCancelButton: false,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'common.ok' ),
                type: type,
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );
        },
        formatTel( v, includePlus = false ) {
            return formatPhoneForTelLink( v, includePlus );
        },
    },
};

</script>
